import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ioteqScrollbarModule } from '@tools/directives/scrollbar/public-api';
import { ioteqHorizontalNavigationBasicItemComponent } from '@tools/components/navigation/horizontal/components/basic/basic.component';
import { ioteqHorizontalNavigationBranchItemComponent } from '@tools/components/navigation/horizontal/components/branch/branch.component';
import { ioteqHorizontalNavigationDividerItemComponent } from '@tools/components/navigation/horizontal/components/divider/divider.component';
import { ioteqHorizontalNavigationSpacerItemComponent } from '@tools/components/navigation/horizontal/components/spacer/spacer.component';
import { ioteqHorizontalNavigationComponent } from '@tools/components/navigation/horizontal/horizontal.component';
import { ioteqVerticalNavigationAsideItemComponent } from '@tools/components/navigation/vertical/components/aside/aside.component';
import { ioteqVerticalNavigationBasicItemComponent } from '@tools/components/navigation/vertical/components/basic/basic.component';
import { ioteqVerticalNavigationCollapsableItemComponent } from '@tools/components/navigation/vertical/components/collapsable/collapsable.component';
import { ioteqVerticalNavigationDividerItemComponent } from '@tools/components/navigation/vertical/components/divider/divider.component';
import { ioteqVerticalNavigationGroupItemComponent } from '@tools/components/navigation/vertical/components/group/group.component';
import { ioteqVerticalNavigationSpacerItemComponent } from '@tools/components/navigation/vertical/components/spacer/spacer.component';
import { ioteqVerticalNavigationComponent } from '@tools/components/navigation/vertical/vertical.component';

@NgModule({
    declarations: [
        ioteqHorizontalNavigationBasicItemComponent,
        ioteqHorizontalNavigationBranchItemComponent,
        ioteqHorizontalNavigationDividerItemComponent,
        ioteqHorizontalNavigationSpacerItemComponent,
        ioteqHorizontalNavigationComponent,
        ioteqVerticalNavigationAsideItemComponent,
        ioteqVerticalNavigationBasicItemComponent,
        ioteqVerticalNavigationCollapsableItemComponent,
        ioteqVerticalNavigationDividerItemComponent,
        ioteqVerticalNavigationGroupItemComponent,
        ioteqVerticalNavigationSpacerItemComponent,
        ioteqVerticalNavigationComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        ioteqScrollbarModule
    ],
    exports     : [
        ioteqHorizontalNavigationComponent,
        ioteqVerticalNavigationComponent
    ]
})
export class ioteqNavigationModule
{
}
